<template>
    <v-container>
        <div v-if="hasPermission('MIETSPIEGEL_BACKEND_WRITE_BERECHNUNGSVORLAGE')" class="d-flex justify-left my-3">
            <v-btn v-on:click="save" outlined large color="indigo" aria-labelled-by="Speichern"><span class="black--text subtitle-1">Speichern</span></v-btn>
        </div>
        <div class="my-3">
            <h1 class="uiTitle header">
                Küchengrundausstattung
            </h1>
            <p class="subTitle">
                Hat Ihr*e Vermieter*in für die Küche eine Grundausstattung (Spülmöglichkeit und Einbauschränke beziehungsweise Kücheninsel/Küchenblock) zur Verfügung gestellt?
            </p>
        </div>
        <div class="mb-5">
            <div class="d-flex flex-column grey lighten-3 font-weight-bold errors" role="alert" v-if="kuechengrundausstattung">
                <div>
                    <v-icon style="color:#c50517">mdi-alert</v-icon>
                    <strong class="red--text">Konflikt!</strong>
                </div>
                <span class="red--text" :aria-labelled-by="getErrorText(selectedData.errorTypes, selectedData.error, selectedData.id)" v-html="getErrorText(selectedData.errorTypes, selectedData.error, selectedData.id)"></span>
                <br/>
                <span class="red--text">Bitte ändern Sie Ihre Eingabe.</span>
            </div>
            <p class="validationError" role="alert" v-if="validationError">
                <v-icon style="color:#c50517">mdi-alert</v-icon><strong>Bitte wählen Sie eine Option aus!</strong>
            </p>
            <v-card class="d-flex justify-center"
                outlined
            >
                <v-list class="py-0" style="width:100%" role="group">
                    <v-list-item-group role="list" tabindex="0" :aria-active-descendant="selectedItem" v-model="selectedItem" color="transparent" active-class="list-selected">
                        <template v-for="(item, index) in items">
                            <v-divider
                                v-if="item.divider"
                                :key="index"
                                aria-hidden="true"
                            ></v-divider>
                            <v-list-item
                                v-else
                                :key="index"
                                tabindex="-1"
                                :id="item.id"
                                v-on:dblclick="selectAndNext(item.id)"
                            >
                                <input class="d-flex justify-center" @focus="focusInputParent" type="radio" tabindex="-1" :checked="isSelected(item.id)" :title="$t('kuechengrundausstattung.' + item.id)">
                                <div class="d-flex flex-column" :style="getColor(item.id)" v-if="hasError(item.error)">
                                    <strong v-if="isSelected(item.id)">Konflikt!</strong>
                                    <strong v-else>Warnung!</strong>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon :style="getColor(item.id)" v-on="on">mdi-alert</v-icon>
                                        </template>
                                        <span :aria-labelled-by="getErrorText()" v-html="getErrorText()"></span>
                                    </v-tooltip>
                                </div>
                                <v-list-item-content aria-hidden="true" style="color: black; margin-left: 8px">
                                    <v-list-item-title :class="(hasError(item.error) ? 'conflictGrey': '')" v-html="$t('kuechengrundausstattung.' + item.id)"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-list-item-group>
                </v-list>
            </v-card>
        </div>
        <!-- BUTTON SECTION -->
        <div class="d-flex justify-center justify-space-around my-3">
            <v-btn v-on:click="back" outlined large color="indigo" aria-labelled-by="Zurück"><span class="black--text subtitle-1">Zurück</span></v-btn>
            <v-btn v-on:click="next" outlined large color="indigo" aria-labelled-by="Weiter"><span class="black--text subtitle-1">Weiter</span></v-btn>
        </div>
        <!-- INFO SECTION -->
        <div>
            <v-card class="d-flex justify-center mt-6" outlined color="indigo" hover>
                <v-expansion-panels>
                    <v-expansion-panel ref="infoPanel">
                        <v-expansion-panel-header @click="changedExpansion" v-if="expanded" aria-label="Info-Bereich Schließen" role="heading" aria-level="2" class="subtitle-1 py-1">Info</v-expansion-panel-header>
                        <v-expansion-panel-header @click="changedExpansion" v-else aria-label="Info-Bereich Öffnen" role="heading" aria-level="2" class="subtitle-1 py-1">Info</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <h3>Küche</h3><br/>
                            <p>Im Folgenden bezeichnet Küche sowohl eine Kochnische, Wohnküche, separate Küche als auch offene Küche. Die Merkmale "Offene Küche" und "Küchenausstattung" können nebeneinander angesetzt werden.</p>
                            <h3>Küchengrundausstattung</h3><br/>
                            <p>Zuschläge für die nachfolgenden Elektrogeräte dürfen nur vergeben werden, wenn die*der Vermieter*in 
                                als Grundausstattung eine Spülmöglichkeit und Einbauschränke zur Verfügung gestellt hat. Die 
                                Einbauschränke können auch in Form einer Kücheninsel/eines Küchenblocks zur Verfügung gestellt 
                                werden.</p>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card>
        </div>
    </v-container>
</template>

<script>
    import {Component, Vue} from 'vue-property-decorator';
    import { EventBus } from '../eventbus';
    import { mapActions, createNamespacedHelpers } from 'vuex';

    const { mapMutations, mapState } = createNamespacedHelpers('error')
    const { mapGetters } = createNamespacedHelpers('user')

    @Component({
        // don't get confused, this is a kuechengrundausstattung ERROR
        computed: { ...mapState(['kuechengrundausstattung']),
                    ...mapGetters(['hasPermission'])},
        methods: { ...mapActions('berechnung', ['SELECT_KUECHENGRUNDAUSSTATTUNG']),
                    ...mapMutations(['SET_KUECHENGRUNDAUSSTATTUNG_ERROR']),
                    ...mapActions('error', ['CHECK_ELEKTROGERAETE_ERROR']) }
    })
    export default class Kuechengrundaustattung extends Vue {

        get error(){
            return this.hasError(this.selectedData.error)
        }

        get selectedData(){
            return this.items.filter(item => item.id === this.selectedItem)[0]
        }

        data() {
            return {
                index: 11,
                selectedItem: this.$store.state.berechnung.selectedKuechengrundausstattung,
                items: [
                    { id: 0 },
                    { divider: true},
                    { id: 1,
                      error: { selectedElektrogeraete: function(el){ return el.some(it => it < 3) } }
                    },
                ],
                validationError: false,
                expanded: false
            };
        }

        focusInputParent(event){
            //only triggered by screenreader
            event.target.parentElement.focus()
            event.preventDefault()
        }

        changedExpansion(event){
            this.expanded = !this.expanded
            event.currentTarget.setAttribute('aria-expanded', this.expanded)
        }

        isSelected(index) {
            return index == this.selectedItem;
        }

        hasError(error){
            /*
             * check if function in error for selected attribute (of different component) matches
             * the stored value (of the different component in the state)
             */
            return error && Object.keys(error).map(key => error[key](this.$store.state.berechnung[key])).some(el => el === true)
        }

        getErrorText(){
            //return errorText for error
            return this.$t('elektrogeraete.error');
        }

        selectAndNext(id) {
            this.$data.selectedItem = id;
            this.next();
        }

        mounted() {
            EventBus.$emit('scroll', this.$data.index)
            this.$refs.infoPanel.$el.firstChild.setAttribute('aria-expanded', false)
            var vm = this;
            const listgroup = document.querySelector('[role="group"]').firstChild
            listgroup.addEventListener('focus', event => {
                event.target.firstChild.focus()
            })
            //item group handling: (un)select on spacebar
            listgroup.addEventListener('keydown', event => this.itemSelection(event, vm))
        }

        itemSelection(event, vm){
            if(event.key !== ' ') return
            const option = event.target.closest('.v-list-item')
            if (!option) return
            const id = parseInt(option.id)
            if(vm.selectedItem === id){
                setTimeout(function(){
                    vm.selectedItem = null
                }, 100)
            }else{
                setTimeout(function(){
                    vm.selectedItem = id
                }, 100)
            }
            event.preventDefault()
        }

        save() {
            EventBus.$emit('getSaveData', this.index)
        }

        next() {
            this.validationError = (this.selectedItem == undefined || this.selectedItem == null);
            if(this.validationError) {
                let alert = document.querySelector('.validationError')
                alert.removeAttribute('role')
                alert.setAttribute("role", "alert")
                return;
            }
            console.log(this.selectedData.id)
            this.SELECT_KUECHENGRUNDAUSSTATTUNG({ selectedKuechengrundausstattung: this.selectedItem,
                                        selectedKuechengrundausstattungError: this.selectedData.error })
            this.CHECK_ELEKTROGERAETE_ERROR()
            if(this.error){
                console.log('found kuechengrundausstattung error')
                this.SET_KUECHENGRUNDAUSSTATTUNG_ERROR(true)
                let alert = document.querySelector('.errors')
                alert.removeAttribute('role')
                alert.setAttribute("role", "alert")
            }else{
                this.SET_KUECHENGRUNDAUSSTATTUNG_ERROR(false)
                this.$router.push('elektrogeraete')
            }
        }

        back() {
            this.$router.push('kueche')
        }

        getColor(index){
            if(this.isSelected(index)){
                return "color:#c50517";
            }
            return "color:blue";
        }
    }
</script>
